'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', 'px !important;\n  color: ', ';\n'], ['\n  font-size: ', 'px !important;\n  color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  text-decoration: none;\n  background: ', ';\n  color: ', ';\n  width: ', 'px;\n  height: ', 'px;\n  line-height: ', 'px;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: bold;\n  vertical-align: middle;\n  overflow: hidden;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);\n  border-style: none none solid none;\n  border-width: 5px;\n  border-color: #c42a00;\n  transition: 0.2s;\n  cursor: pointer;\n  user-select: none;\n  font-size: ', 'px;\n  text-transform: uppercase;\n\n  ', ';\n'], ['\n  display: inline-block;\n  text-decoration: none;\n  background: ', ';\n  color: ', ';\n  width: ', 'px;\n  height: ', 'px;\n  line-height: ', 'px;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: bold;\n  vertical-align: middle;\n  overflow: hidden;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);\n  border-style: none none solid none;\n  border-width: 5px;\n  border-color: #c42a00;\n  transition: 0.2s;\n  cursor: pointer;\n  user-select: none;\n  font-size: ', 'px;\n  text-transform: uppercase;\n\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../libs/colors');

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Loader = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, function (_ref) {
  var size = _ref.size;
  return size;
}, _colors.white);

var Button = _styledComponents2.default.div(_templateObject2, _colors.red, _colors.white, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var size = _ref3.size;
  return size;
}, function (_ref4) {
  var size = _ref4.size;
  return size;
}, function (_ref5) {
  var font = _ref5.font;
  return font;
}, function (_ref6) {
  var pressed = _ref6.pressed;
  return pressed && '\n    transform: translateY(2px);\n    box-shadow: 0 0 1px rgba(0, 0, 0, 0.15);\n    border-color: transparent;\n  ';
});

var Button3D = function (_Component) {
  _inherits(Button3D, _Component);

  function Button3D() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Button3D);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Button3D.__proto__ || Object.getPrototypeOf(Button3D)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      pressed: false
    }, _this.press = function () {
      return _this.setState({
        pressed: true
      });
    }, _this.release = function () {
      return _this.setState({
        pressed: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button3D, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          font = _props.font,
          children = _props.children,
          loading = _props.loading,
          props = _objectWithoutProperties(_props, ['size', 'font', 'children', 'loading']);

      var pressed = this.state.pressed;
      return _react2.default.createElement(Button, _extends({
        size: size,
        font: font,
        pressed: pressed,
        onMouseDown: this.press,
        onMouseUp: this.release
      }, props), loading ? _react2.default.createElement(Loader, {
        size: size / 3,
        icon: 'loading2',
        spin: true
      }) : children);
    }
  }]);

  return Button3D;
}(_react.Component);

Button3D.propTypes = {
  size: _propTypes2.default.number,
  font: _propTypes2.default.number,
  loading: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
Button3D.defaultProps = {
  size: 150,
  font: 20,
  loading: false
};
exports.default = Button3D;